(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2576],{

/***/ 43826:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tutorials/[slug]",
      function () {
        return __webpack_require__(6916);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 28032:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ PreviewBadge; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97324);



function PreviewBadge(param) {
    let { isLive , isTop =false  } = param;
    if (!_utils__WEBPACK_IMPORTED_MODULE_1__/* .isProduction */ .yv && !isLive) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("mx-auto text-lg max-w-prose", isTop ? "mb-14" : "mt-14"),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex justify-center w-full py-1 font-medium text-white uppercase bg-green-500",
                children: "Preview"
            })
        });
    }
    return null;
}


/***/ }),

/***/ 87585:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Pk": function() { return /* binding */ tutorialQuery; },
/* harmony export */   "Tc": function() { return /* binding */ docBySlugQuery; },
/* harmony export */   "Zk": function() { return /* binding */ blogQuery; }
/* harmony export */ });
/* unused harmony exports blogIndexQueryProduction, blogIndexQueryPreview, guidesIndexQueryProduction, guidesIndexQueryPreview, authorQuery, investorQuery, docQuery, pageQuery, siteSettingsQuery, blogSlugsQueryProduction, blogSlugsQueryPreview, blogBySlugQuery, tutorialSlugsQueryProduction, tutorialSlugsQueryPreview, tutorialBySlugQuery, marketingLPSlugsQuery, marketingLPBySlugQuery, docSlugsQuery, navigationQuery */
const blogFields = '\n  _id,\n  name,\n  title,\n  date,\n  excerpt,\n  coverImage,\n  category,\n  mdx,\n  live,\n  "slug": slug.current,\n  "author": author->{name, picture},\n  seo\n';
const tutorialFields = '\n_id,\nname,\ntitle,\nexcerpt,\ncoverImage,\ncategory,\nlive,\n"slug": slug.current,\n"author": author->{name, picture},\ntime,\nmarkdown,\nbody[] {\n  ...,\n  markDefs[]{\n    ...,\n    _type == "internalLink" => {\n      "slug": @.reference->slug\n    }\n  },\n  body[] {\n    ...,\n    markDefs[]{\n      ...,\n      _type == "internalLink" => {\n        "slug": @.reference->slug\n      }\n    }\n  },\n},\nseo\n';
const docFields = '\n  _id,\n  seo,\n  title,\n  subtitle,\n  body[] {\n    ...,\n    markDefs[]{\n      ...,\n      _type == "internalLink" => {\n        "slug": @.reference->slug\n      }\n    },\n    body[] {\n      ...,\n      markDefs[]{\n        ...,\n        _type == "internalLink" => {\n          "slug": @.reference->slug\n        }\n      }\n    },\n  },\n  "slug": slug.current\n';
const authorFields = "\n  _id,\n  name,\n  picture,\n  role,\n  socials,\n  teammate\n";
const investorFields = "\n  _id,\n  name,\n  picture,\n  role,\n  url\n";
const pageFields = '\n  _id,\n  seo,\n  pageText,\n  pageCode,\n  pageImage,\n  pageJSON,\n  body[]{\n    ...,\n    richText[]{\n      ...,\n      markDefs[]{\n        ...,\n        _type == "internalLink" => {\n          "slug": @.reference->slug\n        }\n      }\n    }\n  },\n  "slug": slug.current,\n';
const blogIndexQueryProduction = "\n*[_type == \"blog\" && live == true && !(_id in path('drafts.**'))] | order(date desc, _updatedAt desc) {\n  ".concat(blogFields, "\n}");
const blogIndexQueryPreview = "\n*[_type == \"blog\" && !(_id in path('drafts.**'))]  | order(date desc, _updatedAt desc) {\n  ".concat(blogFields, "\n}");
const guidesIndexQueryProduction = '\n*[(_type == \'tutorial\' || _type == "blog") && live == true && (category == "Guide" || category == "Tutorial") && !(_id in path(\'drafts.**\'))] | order(date desc, _updatedAt desc) {\n  '.concat(blogFields, "\n}");
const guidesIndexQueryPreview = '\n*[(_type == \'tutorial\' || _type == "blog") && (category == "Guide" || category == "Tutorial") && !(_id in path(\'drafts.**\'))] | order(date desc, _updatedAt desc) {\n  '.concat(blogFields, "\n}");
const authorQuery = '\n*[_type == "author"] | order(order asc) {\n  '.concat(authorFields, "\n}");
const investorQuery = '\n*[_type == "investor"] | order(order asc) {\n  '.concat(investorFields, "\n}");
const docQuery = '\n*[_type == "doc"] {\n    _id,\n  title,\n  "slug": slug.current\n}';
const blogQuery = '\n{\n  "blog": *[_type == "blog" && slug.current == $slug] | order(_updatedAt desc)[0]{\n    "body": body[]{\n      ...,\n      authors[]->,\n      markDefs[]{\n        ...,\n        _type == "internalLink" => {\n          "slug": @.reference->slug\n        }\n      },\n      body[] {\n        ...,\n        markDefs[]{\n          ...,\n          _type == "internalLink" => {\n            "slug": @.reference->slug\n          }\n        }\n      }\n},\n    '.concat(blogFields, '\n  },\n  "moreBlogs": *[_type == "blog" && slug.current != $slug] | order(date desc, _updatedAt desc)[0...2] {\n    "body": body[]{\n      ...,\n      authors[]->,\n},\n    ').concat(blogFields, "\n  }\n}");
const tutorialQuery = '\n{\n  "tutorial": *[_type == "tutorial" && slug.current == $slug] | order(_updatedAt desc)[0]{\n    "body": body[]{\n      ...,\n      authors[]->,\n},\n    '.concat(tutorialFields, '\n  },\n  "moreTutorials": *[_type == "tutorial" && slug.current != $slug] | order(date desc, _updatedAt desc)[0...2] {\n    "body": body[]{\n      ...,\n      authors[]->,\n},\n    ').concat(tutorialFields, "\n  }\n}");
const pageQuery = '\n{\n  "page": *[_type == "page" && slug.current == $slug] | order(_updatedAt desc)[0] {\n    content,\n    '.concat(pageFields, "\n  },\n}");
const siteSettingsQuery = '\n*[_type == "siteSettings"] | order(order asc)';
const blogSlugsQueryProduction = '\n*[_type == "blog" && live == true && defined(slug.current)][].slug.current\n';
const blogSlugsQueryPreview = '\n*[_type == "blog" && defined(slug.current)][].slug.current\n';
const blogBySlugQuery = '\n*[_type == "blog" && slug.current == $slug][0] {\n  '.concat(blogFields, "\n}\n");
const tutorialSlugsQueryProduction = '\n*[_type == "tutorial" && live == true && defined(slug.current)][].slug.current\n';
const tutorialSlugsQueryPreview = '\n*[_type == "tutorial" && defined(slug.current)][].slug.current\n';
const tutorialBySlugQuery = '\n*[_type == "tutorial" && slug.current == $slug][0] {\n  '.concat(tutorialFields, "\n}\n");
const marketingLPSlugsQuery = '\n*[_type == "marketing-lp" && defined(slug.current)][].slug.current\n';
const marketingLPBySlugQuery = '\n{\n  "page": *[_type == "marketing-lp" && slug.current == $slug][0] {\n    '.concat(pageFields, "\n  }\n}\n");
const docSlugsQuery = '\n*[_type == "doc" && defined(slug.current)][].slug.current\n';
const docBySlugQuery = '\n*[_type == "doc" && slug.current == $slug] | order(_updatedAt desc)[0] {\n  '.concat(docFields, "\n}\n");
const navigationQuery = '\n*[navId.current match "docs-*"] | order(order asc) {\n  name,\n "navId": navId.current,\n "categories": linkCategories[]{\n   "categoryId": categoryId.current,\n   categoryName,\n   links[] {\n     _key,\n     title,\n     "slug": internalLink->slug.current,\n     "url": externalLink.href,\n     "childLinks": links[]{\n       _key, \n       title, \n       "slug": internalLink->slug.current, \n       "url": externalLink.href\n     }\n   }\n }\n}\n';


/***/ }),

/***/ 6916:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ TutorialPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_error__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12918);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(15186);
/* harmony import */ var _lib_queries__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87585);
/* harmony import */ var _lib_sanity__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53822);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(97324);
/* harmony import */ var _components_blog__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(28032);
/* harmony import */ var _components_sanity_sane_image__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27013);
/* harmony import */ var _lib__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(58038);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(35547);












const { tutorials  } = _lib__WEBPACK_IMPORTED_MODULE_7__/* .URLS */ .ns;
var __N_SSG = true;
function TutorialPage(param) {
    let { data ={} , preview  } = param;
    var ref, ref1;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const slug = data === null || data === void 0 ? void 0 : (ref = data.tutorial) === null || ref === void 0 ? void 0 : ref.slug;
    const live = data === null || data === void 0 ? void 0 : (ref1 = data.tutorial) === null || ref1 === void 0 ? void 0 : ref1.live;
    const { data: { tutorial  }  } = (0,_lib_sanity__WEBPACK_IMPORTED_MODULE_5__/* .usePreviewSubscription */ .$r)(_lib_queries__WEBPACK_IMPORTED_MODULE_4__/* .tutorialQuery */ .Pk, {
        params: {
            slug
        },
        initialData: data,
        enabled: preview && slug
    });
    if (!router.isFallback && !slug || utils__WEBPACK_IMPORTED_MODULE_8__/* .isProduction */ .yv && !live) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_error__WEBPACK_IMPORTED_MODULE_1__["default"], {
            statusCode: 404
        });
    }
    return router.isFallback ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: "Loading"
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative py-16 overflow-hidden",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "hidden lg:block lg:absolute lg:inset-y-0 lg:h-full lg:w-full",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "relative h-full mx-auto text-lg max-w-prose",
                    "aria-hidden": "true"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_blog__WEBPACK_IMPORTED_MODULE_9__/* .PreviewBadge */ .P, {
                isLive: tutorial.live,
                isTop: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("article", {
                className: "relative px-4 clerk-tutorial sm:px-6 lg:px-8",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "mx-auto text-lg max-w-prose",
                        children: [
                            tutorial.coverImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_sanity_sane_image__WEBPACK_IMPORTED_MODULE_6__/* .SaneImage */ .Q, {
                                width: 700,
                                src: tutorial.coverImage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "block text-base font-semibold tracking-wide text-gray-600 uppercase mt-14",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                        legacyBehavior: true,
                                        href: tutorials,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            children: "Tutorials"
                                        })
                                    }),
                                    " \xbb  ".concat(tutorial.category)
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                className: "block mt-2 text-3xl font-extrabold leading-8 tracking-tight text-gray-900 sm:text-4xl",
                                children: tutorial.title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                                className: "block mt-2 text-sm font-semibold leading-8 tracking-tight text-gray-500 text sm:text-1xl",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_outline__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                        className: "inline w-6 h-6"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: "Estimated time:"
                                    }),
                                    " ",
                                    tutorial.time
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex items-center mt-6",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex-shrink-0",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "sr-only",
                                                children: tutorial.author.name
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_sanity_sane_image__WEBPACK_IMPORTED_MODULE_6__/* .SaneImage */ .Q, {
                                                className: "block w-10 h-10 rounded-full",
                                                src: tutorial.author.picture,
                                                height: 40,
                                                width: 40,
                                                quality: 100
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "ml-3",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "text-sm font-medium text-gray-900",
                                            children: tutorial.author.name
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mx-auto mt-6 prose prose-lg text-gray-500 prose-clerk-blue",
                        children: tutorial.body ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_11__/* .SaneBlockChakra */ .C, {
                            blocks: tutorial.body
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_11__/* .SaneBlockChakra */ .C, {
                            blocks: {
                                _type: "markdown",
                                markdown: tutorial.markdown
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex flex-row justify-center w-full my-10",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                    legacyBehavior: true,
                    href: tutorials,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        className: "z-10 flex items-center justify-center w-1/2 px-2 py-3 mx-2 mt-4 text-base font-medium text-white border border-transparent rounded-md shadow-md lg:w-1/6 bg-clerk-blue hover:bg-clerk-blue-hover md:py-4 md:text-lg whitespace-nowrap btn",
                        children: "More Tutorials"
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_blog__WEBPACK_IMPORTED_MODULE_9__/* .PreviewBadge */ .P, {
                isLive: tutorial.live
            })
        ]
    });
}


/***/ }),

/***/ 12918:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(97345)


/***/ }),

/***/ 15186:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72408);


function ClockIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (ClockIcon);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6241,9385,5547,9774,2888,179], function() { return __webpack_exec__(43826); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);